/* Phase 36 — Slide-over modal that wraps DrinkWizard for the cocktail card button. */
import React from "react";
import { X, Martini } from "lucide-react";
import DrinkWizard from "./DrinkWizard";

export default function DrinkModal({ cocktail, onClose }) {
  if (!cocktail) return null;
  return (
    <div className="fixed inset-0 z-50 flex" data-testid="drink-modal">
      <div className="flex-1 bg-bg/70 backdrop-blur-sm" onClick={onClose} />
      <div className="w-full max-w-3xl bg-bg border-l border-white/10 shadow-2xl overflow-y-auto">
        <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-3 border-b border-white/10 bg-bg/95 backdrop-blur">
          <div className="flex items-center gap-2">
            <Martini size={16} className="text-brand" />
            <div>
              <div className="text-sm font-medium">Drink Intelligence</div>
              <div className="text-[11px] text-ink-muted">{cocktail.name}</div>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            data-testid="drink-modal-close"
            className="p-1 rounded hover:bg-white/10"
          >
            <X size={18} />
          </button>
        </div>
        <div className="p-5">
          <DrinkWizard cocktail={cocktail} compact />
        </div>
      </div>
    </div>
  );
}
